import { Button } from '../../ui/button';
import { PasswordInput } from '../../ui/password-input';
import { Label } from '../../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../../ui/dialog';
import { ResetPasswordDialogProps } from './userTypes';

export function ResetPasswordDialog({
  open,
  onOpenChange,
  selectedUser,
  newPassword,
  setNewPassword,
  loading,
  onSubmit
}: ResetPasswordDialogProps) {
  const handleCancel = () => {
    onOpenChange(false);
    setNewPassword('');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Redefinir senha</DialogTitle>
          <DialogDescription>
            Defina uma nova senha temporaria para {selectedUser?.name}.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={onSubmit} className="space-y-3">
          <div className="space-y-2">
            <Label htmlFor="new-password">Nova senha</Label>
            <PasswordInput
              id="new-password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              placeholder="Minimo de 8 caracteres"
              minLength={8}
              required
            />
            <p className="text-xs text-muted-foreground">
              O usuario deve alterar esta senha no primeiro acesso.
            </p>
          </div>

          <DialogFooter>
            <Button
              variant="outline"
              type="button"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={loading || newPassword.length < 8}
            >
              {loading ? 'Salvando...' : 'Redefinir senha'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
